import { CardGroupCard } from '@elearning-platform/ui';

export const mockSkeletonCard: CardGroupCard = {
  image: '',
  title: '',
  tags: ['', ''],
  category: '',
};
